// Maps a filter category name (which doubles as an identifier and must NOT be
// mutated) to a stable i18n key used ONLY for display. Callers should pass
// `defaultValue` (the original English name) so unknown/dynamic filter names
// fall back gracefully when no translation entry exists.
export const getFilterLabelKey = (name: string): string =>
  `filters_${name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")}`;
